<div class="table-responsive gung-responsive">
  <table class="table table-striped-mobile">
    <thead>
      <tr>
        <th translate>ID</th>
        <th translate>NAME</th>
        <!-- <th translate>VARUGRUPPKOD</th> -->
        <th style="min-width: 200px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of mappedData; trackBy: trackByFn">
        <!-- <ng-template libCustomHost></ng-template> -->
        <td [attr.data-label]="'ID' | translate">
          <a [routerLink]="[(data.product?.productType === 'concept' ? '/concept' : '/product/'), data.product.id]" class="text-dark">
            {{ data.product.id }}
          </a>
        </td>
        <td [attr.data-label]="'NAME' | translate">
          <a [routerLink]="[(data.product?.productType === 'concept' ? '/concept' : '/product/'), data.product.id]" class="text-dark">
            {{ data.product.name }}
          </a>
        </td>
        <!-- <td [attr.data-label]="'VARUGRUPPKOD' | translate">
            <lib-gung-meta-output
                suppressLabel="true"
                [value]="data.product.extra.ar.varugruppkod"
                metadataTable="vg"
                metaOptionName="varugruppbeskr"></lib-gung-meta-output>
        </td> -->
        <td [attr.data-label]="'BUY' | translate">
            <lib-buy-btn
                [id]="data.product.id"
                [product]="data.product"
                [productPartialId]="'artv_' + productPartialId"
                [disabledAdd]="disabled.includes(data.product.id)"
                [maximumOrderQuantity]="maxQty"
            ></lib-buy-btn>
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="findError" class="mb-2 text-center">
    {{ errorMessage }}
  </div>
</div>
<div *ngIf="findError" class="col-12 mb-2 text-center">
  {{ errorMessage }}
</div>
